import AiImageGenerateTab from './GenerateTab'
import AiImageHistoryTab from './HistoryTab'
import { AI_GENERATE_TAB_KEY, AI_HISTORY_TAB_KEY } from './consts'

export const TAB_CONTENT = {
  [AI_GENERATE_TAB_KEY]: <AiImageGenerateTab />,
  [AI_HISTORY_TAB_KEY]: <AiImageHistoryTab />
}
